module.exports = __webpack_public_path__ + "img/xin1.e8ea49eb.png";